// 阿塞拜疆
module.exports = {
    i: {
        locale: 'az',
        select: {
            placeholder: 'zəhmət olmasa seçin',
            noMatch: 'Uyğun məlumat yoxdur',
            loading: 'Yüklənir'
        },
        table: {
            noDataText: 'Məlumat yoxdur',
            noFilteredDataText: 'Hələ filtr nəticəsi yoxdur',
            confirmFilter: 'filtr',
            resetFilter: 'sıfırlama',
            clearFilter: 'hamısı',
            sumText: 'ümumi'
        },
        datepicker: {
            selectDate: 'Tarix seçin',
            selectTime: 'seçim müddəti',
            startTime: 'Başlama vaxtı',
            endTime: "Axır Zaman",
            clear: 'Boş',
            ok: 'Əlbəttə',
            datePanelLabel: '[yyyy il] [m ay]',
            month: 'ay',
            month1: 'Yanvar',
            month2: 'fevral',
            month3: 'Mart',
            month4: "Aprel",
            month5: 'Bilər',
            month6: 'iyun',
            month7: 'iyul',
            month8: 'avqust',
            month9: 'sentyabr',
            month10: 'Oktyabr',
            month11: 'noyabr',
            month12: 'dekabr',
            year: 'il',
            weekStartDay: '0',
            weeks: {
                sun: 'gün',
                mon: 'bir',
                tue: 'iki',
                wed: 'üç',
                thu: 'Dörd',
                fri: 'beş',
                sat: 'altı'
            },
            months: {
                m1: 'Yanvar',
                m2: 'fevral',
                m3: 'Mart',
                m4: "Aprel",
                m5: 'Bilər',
                m6: 'iyun',
                m7: 'iyul',
                m8: 'avqust',
                m9: 'sentyabr',
                m10: 'Oktyabr',
                m11: 'noyabr',
                m12: 'dekabr'
            }
        },
        transfer: {
            titles: {
                source: 'Mənbə siyahısı',
                target: "Məqsəd siyahısı"
            },
            filterPlaceholder: 'Axtarış məzmununu daxil edin',
            notFoundText: "siyahı boşdur"
        },
        modal: {
            okText: 'Əlbəttə',
            cancelText: 'Ləğv et'
        },
        poptip: {
            okText: 'Əlbəttə',
            cancelText: 'Ləğv et'
        },
        page: {
            prev: 'Əvvəlki səhifə',
            next: 'Növbəti səhifə',
            total: 'ümumi',
            item: 'zolaq',
            items: 'zolaq',
            prev5: '5 səhifə irəli',
            next5: '5 səhifə geri',
            page: 'Məqalə / Səhifə',
            goto: 'atla',
            p: 'Səhifə'
        },
        rate: {
            star: 'ulduz',
            stars: 'ulduz'
        },
        time: {
            before: 'irəli',
            after: 'geri',
            just: 'sadəcə',
            seconds: 'İkinci',
            minutes: 'dəqiqə',
            hours: 'Saat',
            days: 'səma'
        },
        tree: {
            emptyText: 'Məlumat yoxdur'
        }
    }
};